import { useCallback } from 'react';

import { useLocalStorageValue } from '#src/app/shared/hooks/storage';

type UseOneTimeBadgeReturn = {
	data: {
		showBadge: boolean;
	};
	actions: {
		markBadgeAsViewed: () => void;
	};
};

export function useOneTimeBadge(storageKey: string): UseOneTimeBadgeReturn {
	const [badgeViewed, setBadgeViewed] = useLocalStorageValue(storageKey);

	const markBadgeAsViewed = useCallback(() => {
		setBadgeViewed('true');
	}, [setBadgeViewed]);

	return {
		data: {
			showBadge: badgeViewed !== 'true',
		},
		actions: {
			markBadgeAsViewed,
		},
	};
}
